import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Contracts from '../../../api/api-contracts';
import { Sync } from '../../../api/api-sync';
import _ from 'lodash';
import { Modal } from '../elements-modal/modal';
import { FormBuilder } from 'shared-components/forms/form';
import { RadioGroup } from '../elements-inputs/radio-group';
import { TosCTAdisclaimer } from 'shared-components/terms/cta-disclaimer';
import { BlockDayNotificationModal } from './block-day-notification-modal';
import { OpHoursNotificationModal } from './OpHoursNotificationModal';
import { HostCancelConfirmationModal } from './host-cancel-confirmation-modal';
import { HostCancelSpaceUnavailableModal } from './host-cancel-space-unavailable-modal';
import { getDisplayDateTime } from '../elements-forms/schedule';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

class BookingActionModal extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      errorText: ''
    };

    this.handleResponse = this.handleResponse.bind(this);
    this.getModalDetails = this.getModalDetails.bind(this);
    this.analyticsPayload = this.analyticsPayload.bind(this);
    this.cancelActionCb = this.cancelActionCb.bind(this);
    this.handleResponseCb = this.handleResponseCb.bind(this);
    this.confirmHostCancellation = this.confirmHostCancellation.bind(this);
    this.updateContracts = this.updateContracts.bind(this);
  }

  componentDidMount () {
    const { action } = this.props;
    if ('HOST_CANCEL' === action) {
      const payload = this.analyticsPayload(null, 'Cancel Booking Viewed');
      analyticsIntegrations.cancelBooking('Cancel Booking Viewed', payload);
    }
  }

  getModalDetails (name) {
    const isInstantBooking = _.get(this.props, 'details.is_instant_booking');
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();
    const modals = {
      HOST_CANCEL: {
        heading: <FormattedMessage
          id='inbox.booking_action_modal.cancel_booking_heading'
          defaultMessage='Cancel Booking'
        />,
        bodyTop:
        <div className="booking-update-instructions text-center">
          { isInstantBooking ?
            <p>
              <FormattedMessage
                id='inbox.booking_action_modal.instant_book'
                defaultMessage='Instant Book cancellations are penalty-free under certain circumstances. {link}'
                values={{
                  link: <a href={`//support.peerspace.com/hc/${zendeskLocale}/articles/360018674331-Can-I-cancel-an-Instant-Booking`} target="_blank" rel="noopener noreferrer">
                    <FormattedMessage id='inbox.booking_action_modal.instant_book_learn_more' defaultMessage='Learn More' />
                  </a>
                }}
              />
            </p> :
            <p>
              <FormattedMessage
                id='inbox.booking_action_modal.cancellations_difficult'
                defaultMessage='Cancellations are very difficult for guests and may result in penalties to your account. {link}'
                values={{
                  link: <a href={`//support.peerspace.com/hc/${zendeskLocale}/articles/201745713-What-if-I-need-to-cancel-a-booking-I-confirmed-with-a-guest`} target="_blank" rel="noopener noreferrer">
                    <FormattedMessage id='inbox.booking_action_modal.cancellations_difficult_learn_more' defaultMessage='Learn More' />
                  </a>
                }}
              />
            </p>
          }
        </div>,
        form: {
          formname: 'host_cancel',
          subHeading: <FormattedMessage id='inbox.booking_action_modal.why_cancelling_heading' defaultMessage='Tell Peerspace why you are cancelling' />,
          formInputs: [{ custom: () => {
            return (<RadioGroup
              isRequired
              ref="radio"
              inputData={[
                {
                  ID: 'incorrect-booking',
                  value: 'The guest booked the incorrect listing type',
                  displayText: <FormattedMessage id='inbox.booking_action_modal.incorrect_type' defaultMessage='The guest booked the incorrect listing type' />
                },
                {
                  ID: 'violates-rules',
                  value: 'The booking violates the rules posted on my listing',
                  displayText: <FormattedMessage id='inbox.booking_action_modal.booking_violates' defaultMessage='The booking violates the rules posted on my listing' />
                },
                {
                  ID: 'guest-unresponsive',
                  value: 'The guest is unresponsive',
                  displayText: <FormattedMessage id='inbox.booking_action_modal.guest_unresponsive' defaultMessage='The guest is unresponsive' />
                },
                {
                  ID: 'space-unavailable',
                  value: 'My space is no longer available',
                  displayText: <FormattedMessage id='inbox.booking_action_modal.no_longer_available' defaultMessage='My space is no longer available' />
                }
              ].concat(isInstantBooking ? [{
                ID: 'unfavorable-reviews',
                value: 'The guest has several unfavorable reviews',
                displayText: <FormattedMessage id='inbox.booking_action_modal.guest_unfavorable' defaultMessage='The guest has several unfavorable reviews' />
              }] : []
              )}
              groupName="host-cancel-reason"
              customErrorMessage={ <FormattedMessage id='inbox.booking_action_modal.select_reason' defaultMessage='Please select your reason' /> }
            />);
          } },
          {
            ref: 'host_cancel_text',
            elementID: 'booking_cancel_reason',
            inputFieldName: 'required_textbox_response',
            optional: false,
            customLabel: this.textResponseLabel()
          }],
          buttonText: <FormattedMessage id='inbox.booking_action_modal.cancel_booking' defaultMessage='Cancel booking' />,
          afterCTA: <TosCTAdisclaimer
            location={isInstantBooking ? 'cancelBkgInsta' : 'cancelBkg'}
            buttonLabel={ <FormattedMessage id='inbox.booking_action_modal.cancel_booking_cta' defaultMessage='Cancel booking' /> }
          />
        }
      },
      GUEST_WITHDRAW: {
        heading: <FormattedMessage id='inbox.booking_action_modal.withdraw_booking' defaultMessage='Withdraw booking' />,
        bodyTop: <div className="booking-update-instructions">
          <p>
            <FormattedMessage
              id='inbox.booking_action_modal.tell_host_withdrawing'
              defaultMessage='Tell your host why you are withdrawing your booking request. Once withdrawn, the temporary hold will be removed from your credit card.'
            />
          </p>
        </div>,
        form: {
          formname: 'guest_withdraw',
          formInputs: [{ custom: () => {
            return (<RadioGroup
              isRequired
              ref="radio"
              inputData={[
                {
                  ID: 'another',
                  value: 'I found another space',
                  displayText: <FormattedMessage id='inbox.booking_action_modal.another_space' defaultMessage='I found another space' />
                },
                {
                  ID: 'not-happening',
                  value: 'My event is cancelled',
                  displayText: <FormattedMessage id='inbox.booking_action_modal.event_cancelled' defaultMessage='My event is cancelled' />
                },
                {
                  ID: 'date-change',
                  value: 'My dates are changing',
                  displayText: <FormattedMessage id='inbox.booking_action_modal.dates_changing' defaultMessage='My dates are changing' />
                },
                {
                  ID: 'too-expensive',
                  value: 'This space is too expensive',
                  displayText: <FormattedMessage id='inbox.booking_action_modal.space_expensive' defaultMessage='This space is too expensive' />
                },
                {
                  ID: 'other',
                  value: '',
                  displayText: <FormattedMessage id='inbox.booking_action_modal.other' defaultMessage='Other' />,
                  collectUserInput: true
                }
              ]}
              groupName="decline-reason"
            />);
          } }],
          buttonText: <FormattedMessage id='inbox.booking_action_modal.withdraw_booking_button' defaultMessage='Withdraw booking' />
        }
      }
    };
    return modals[name];
  }

  textResponseLabel () {
    return (
      <div className="gutter margin-xl-bottom">
        <hr style={{ marginTop: 0 }} />
        <div className="h6">
          <FormattedMessage
            id='inbox.booking_action_modal.why_cancelling'
            defaultMessage='Tell your guest why you are cancelling'
          />
        </div>
      </div>
    );
  }

  closeBehavior () {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    $('#modal-container').modal('hide');
  }

  updateContracts (form, cb, refs) {
    const { bookingId, action } = this.props;
    const value = refs.radio ?
      refs.radio.returnRadioGroupValue()
      :
      $('#booking_cancel_reason').val();
    const payload = {
      reason: value
    };

    if ('HOST_CANCEL' === action) {
      const analyticsPayload = this.analyticsPayload(value, 'Cancel Booking Submitted');
      analyticsIntegrations.cancelBooking('Cancel Booking Submitted', analyticsPayload);
    }

    switch (action) {
    case 'GUEST_WITHDRAW':
      Contracts.updateRequest(payload, bookingId, PSSessions.Cookies('PSAccess'), 'withdraw', (response) => {
        cb(response, value);
      });
      break;
    case 'HOST_CANCEL':
      return this.confirmHostCancellation(this.props.bookingId, {
        private_reason: value,
        reason: refs.host_cancel_text.getValue()
      });
    default:
      break;
    }
  }

  analyticsPayload (reason, action) {
    const { userType, bookingId, details } = this.props;
    const payload = {
      booking_id: bookingId,
      initiated_by: userType
    };

    const submittedPayload = {
      cancel_reason: reason,
      booking_target_date: _.get(details, 'schedule'),
      cancel_date: new Date()
    };

    // refund is hardcoded to 100% atm
    const confirmedPayload = {
      amount_refund: _.get(details, 'payment')
    };

    switch (action) {
      case 'Cancel Booking Viewed':
        return payload;
      case 'Cancel Booking Submitted':
        return _.assign(payload, submittedPayload);
      case 'Cancel Booking Confirmation':
        return _.assign(payload, submittedPayload, confirmedPayload);
      default:
        return payload;
    }
  }

  handleResponse (resp, value) {
    if (200 === resp.statusCode) {
      this.props.callback(() => {
        this.handleResponseCb(resp, value);
      });
    } else {
      this.setState({
        errorText: <FormattedMessage id='inbox.booking_action_modal.error_refresh' defaultMessage='An error occurred. Please refresh the page and try again.' />
      });
    }
  }

  handleResponseCb (resp, value) {
    const { iosWebView } = this.props;
    if ('cancel' === this.props.actionType) {
      this.cancelActionCb(resp, value);
    } else {
      const bookingId = _.get(resp, 'control_id', '');
      const spaceRentalContract = _.find(_.get(resp, 'contracts', []), { type: 'SPACE_RENTAL' });
      const spaceId = _.get(spaceRentalContract, 'meta.booking.space_id', '');

      this.closeBehavior();
      if ('The space is not available at that time' === value && !iosWebView) {
        const timeZoneId = _.get(spaceRentalContract, 'meta.booking.start.timezone.name', '');
        const sched = getDisplayDateTime({ timeZoneId, schedule: _.get(spaceRentalContract, 'meta.booking.schedule', []) });
        Sync.fetchCalendarStatus(spaceId, PSSessions.Cookies('PSAccess'), (res) => {
          // Avoided using an error conditional because we want to show
          // the modal regardless of whether the API call is successful or not.
          // We will show the Sync CTA as the default for the modal.
          const syncConnected = 'CONNECTED' === (res || {}).obj_state;
          ReactDOM.render(
            <SharedIntlProviderHOC>
              <BlockDayNotificationModal
                onClose={this.closeBehavior}
                schedule={sched}
                reason={value}
                bookingId={bookingId}
                spaceId={spaceId}
                syncConnected={syncConnected}
              />
            </SharedIntlProviderHOC>, document.getElementById('modal-container')
          );
        });
      } else if ('This request is outside our operating hours' === value && !iosWebView) {
        ReactDOM.render(
          <SharedIntlProviderHOC>
            <OpHoursNotificationModal
              onClose={this.closeBehavior}
              reason={value}
              bookingId={bookingId}
              spaceId={spaceId}
            />
          </SharedIntlProviderHOC>,
          document.getElementById('modal-container')
        );
      }
    }
  }

  cancelActionCb (resp, value) {
    const payload = this.analyticsPayload(value, 'Cancel Booking Confirmation');
    analyticsIntegrations.cancelBooking('Cancel Booking Confirmation', payload);
    this.closeBehavior();
    if ('My space is no longer available' === value) {
      const spaceRentalContract = _.find(resp.contracts, { type: 'SPACE_RENTAL' }, {});
      const spaceId = _.get(spaceRentalContract, 'meta.booking.space_id');
      ReactDOM.render(
        <SharedIntlProviderHOC>
          <HostCancelSpaceUnavailableModal
            onClose={this.closeBehavior}
            spaceId={spaceId}
          />
        </SharedIntlProviderHOC>,
        document.getElementById('modal-container')
      );
    }
  }

  confirmHostCancellation (bookingId, payload) {
    this.closeBehavior();
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <HostCancelConfirmationModal
          onClose={this.closeBehavior}
          bookingId={bookingId}
          payload={payload}
          handleResponseCb={this.handleResponse}
        />
      </SharedIntlProviderHOC>, document.getElementById('modal-container')
    );
  }

  render () {
    const { action } = this.props;
    const m = this.getModalDetails(action);
    return (
      <Modal
        addCloseIcon
        show
        modalID="booking-update"
        modalSize="sm-size"
        modalType="standard"
        header={ m.heading }
        body={
          <div>
            { m.bodyTop }
            <FormBuilder
              formname="Booking Update Form"
              formStyle="modal-plus"
              formInputs={ m.form.formInputs }
              submitAction={ this.updateContracts }
              submitCallback={ this.handleResponse }
              subHeading={ m.form.subHeading }
              buttonText={ m.form.buttonText }
              errorText={ this.state.errorText }
              afterCTA={ m.form.afterCTA ? m.form.afterCTA : null }
            />
          </div>
        }
        closeBehavior={ this.closeBehavior }
      />
    );
  }
}

BookingActionModal.propTypes = {
  bookingId: PropTypes.string, // id of the booking to update
  userType: PropTypes.string, // host or guest
  actionType: PropTypes.string, // action happening (ex: accept, cancel)
  action: PropTypes.string, // key for updateModals object
  callback: PropTypes.func, // loop back for parent state
  iosWebView: PropTypes.bool
};

export const renderBookingModal = (bookingId, userType, actionType, action, callback, payload, iosWebView) => {
  ReactDOM.render(
    <SharedIntlProviderHOC>
      <BookingActionModal
        bookingId={bookingId}
        userType={userType}
        actionType={actionType}
        action={action}
        callback={callback}
        details={payload}
        iosWebView={iosWebView}
      />
    </SharedIntlProviderHOC>, document.getElementById('modal-container'));
};
